import { Mail } from "lucide-react";

export default function MobileCoachCTA() {
    const jump = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    return (
        <button
            onClick={jump}
            className="lg:hidden fixed bottom-4 right-4 z-40 btn-gold shadow-lg shadow-brand-gold/20"
            data-testid="mobile-coach-cta"
        >
            <Mail size={14} /> Coach Contact
        </button>
    );
}
